import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '@modules/shared.module';

@Component({
  selector: 'app-button-edit',
  standalone: true,
  imports: [MatIconModule,MatButtonModule],
  template: `<button mat-raised-button color="primary" [disabled]="disabled" name="Modificar">
  <mat-icon>edit</mat-icon> Modificar
</button>`,
  styleUrls: ['./button-edit.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonEditComponent {
  @Input() disabled : boolean = false
 }
